<script lang="ts">
  import {ResiPlaylistFull} from '@/types/integrations';
  import {createEventDispatcher} from 'svelte';
  import MediaCard from './MediaCard.svelte';
  import MediaCardSkeleton from './MediaCardSkeleton.svelte';
  import SearchInput from './SearchInput.svelte';

  export let playlistAsync: Promise<ResiPlaylistFull>;

  const dispatch = createEventDispatcher<{
    back: void;
  }>();

  let filterText = '';
</script>

<div>
  {#await playlistAsync}
    <div class="mb-4 h-5 w-1/3 animate-pulse rounded bg-neutral-200" aria-label="Loading playlist title" />
    <ul class="grid max-h-[430px] min-h-[430px] grid-cols-3 gap-3 overflow-y-auto">
      <MediaCardSkeleton />
    </ul>
  {:then playlist}
    <div class="mb-4 flex items-center justify-between gap-x-6">
      <div class="flex min-w-0 items-center gap-x-3">
        <button
          on:click={() => dispatch('back')}
          class="flex items-center justify-center rounded-full px-3 py-2 hover:bg-zinc-100"
          aria-label="Close"
        >
          <i class="fa-solid fa-chevron-left text-lg text-gray-400"></i>
        </button>
        <h1 class="truncate text-xl font-bold">{playlist.name}</h1>
      </div>
      <SearchInput bind:value={filterText} placeholder="Search for a video title" />
    </div>

    <ul class="grid max-h-[430px] min-h-[430px] grid-cols-3 gap-3 overflow-y-auto">
      {#each playlist.videos.filter(v => v.title.toLowerCase().includes(filterText.toLowerCase())) as video (video.id)}
        <MediaCard item={video} on:click />
      {/each}
    </ul>
  {/await}
</div>
